import React from 'react';
import PropTypes from 'prop-types';

import LinkIcon from 'src/assets/common/link.svg';

import { EXISTING_INDUSTRY_URL, NEW_INDUSTRY_DOCS } from './constants';
import styles from './styles.module.scss';

const ExternalLink = ({ href, children }) => (
  <a
    className={styles.link}
    href={href}
    target="_blank"
    rel="noreferrer"
  >
    {children}
    <img src={LinkIcon} alt="" />
  </a>
);

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default function AIEvaluateProcessPage() {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageTitle}>
        AI自動評價建置流程
      </div>

      <div className={styles.card}>
        <div className={styles.intro}>
          因應 AI 自動評價功能的使用需求，相關作業流程說明如下：
        </div>

        <section className={styles.block}>
          <div className={styles.blockTitle}>既有產業</div>
          <p>
            可先檢視既有產業與專案：
            <ExternalLink href={EXISTING_INDUSTRY_URL}>點擊瀏覽</ExternalLink>
          </p>
          <p>若為先前已建立的產業，在系統開啟 AI 自動評價功能後，請先通知研發組專案電子報產品經理。</p>
          <p>研發組需先進行相關設定與串接，完成後系統才能正常產出 AI 評價結果。</p>
          <p>預計設定與串接時間約需 3～4 個工作天。</p>
        </section>

        <section className={styles.block}>
          <div className={styles.blockTitle}>新增產業</div>
          <p>如有新增產業的需求，請先於組內討論並確認開發的必要性，以及與其他開發項目的優先順序。</p>
          <p>由於新增產業涉及開發人力與時間成本，我們將依據整體排程及需求優先順序安排後續開發。</p>
          <p className={styles.gap}>確認需求後，請協助提供以下資料：</p>
          <ol>
            {NEW_INDUSTRY_DOCS.map(({ label, url }) => (
              <li key={url}>
                <ExternalLink href={url}>{label}</ExternalLink>
              </li>
            ))}
          </ol>
        </section>

        <div className={styles.footer}>
          請於提出需求前先完成相關討論與資料準備，以利後續評估及開發排程安排，謝謝配合。
        </div>
      </div>
    </div>
  );
}
